import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Flex, Modal, Table, Tag, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { clrs } from "../../constants/colors";
import MyText from "../../components/UI/Text/MyText";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import user_icon from "./images/user_icon.png";
import img1 from "./images/1.png";
import img2 from "./images/2.jpg";
import img3 from "./images/3.jpg";
import img5 from "./images/5.jpg";
import img10 from "./images/10.jpg";
import img11 from "./images/11.jpeg";
import img14 from "./images/14.jpeg";
import img15 from "./images/15.jpg";
import img19 from "./images/19.jpg";
import img23 from "./images/23.JPG";
import img25 from "./images/25.jpg";
import img27 from "./images/27.jpg";
import img29 from "./images/29.png";
import imgEldos from "./images/eldos.jpeg";
import imgArtemBilo from "./images/artem_bilo.jpeg";
import imgEvgenyBilo from "./images/evgeny_bilo.jpeg";
import imgMedetkhan from "./images/medetkhan.jpeg";
import imgAmangeldi from "./images/amangeldi.jpg";
import imgTasybayev from "./images/tasybayev.jpeg";
import imgStelvaga from "./images/stelvaga.jpeg";
import imgOmarova from "./images/omarova.jpeg";
import imgGoncharenko from "./images/goncharenko.jpeg";
import imgKazhibekov from "./images/kazhibekov.jpeg";
import imgBayandina from "./images/bayandina.jpeg";
import { PersonNeftissov } from "./components/PersonNeftissov";
import { PersonBiloshchytskyi } from "./components/PersonBiloshchytskyi";
import { PersonKuchanskyi } from "./components/PersonKuchanskyi";
import { PersonToxanov } from "./components/PersonToxanov";
import { PersonAbzhanova } from "./components/PersonAbzhanova";
import { PersonKazambayev } from "./components/PersonKazambayev";
import { PersonKirichenko } from "./components/PersonKirichenko";
import { PersonKambarova } from "./components/PersonKambarova";
import { PersonAubakirova } from "./components/PersonAubakirova";
import { PersonMikryakov } from "./components/PersonMikryakov";
import { PersonBakytkereiuly } from "./components/PersonBakytkereiuly";
import { PersonZhalmagambetova } from "./components/PersonZhalmagambetova";
import { PersonKomandirov } from "./components/PersonKomandirov";
import { PersonZhandaulet } from "./components/PersonZhandaulet";
import { PersonArtemBiloshchytskyi } from "./components/PersonArtemBiloshchytskyi";
import { PersonEvgenyBiloshchytskyi } from "./components/PersonEvgenyBiloshchytskyi";
import { PersonMedetkhan } from "./components/PersonMedetkhan";
import { PersonAmangeldi } from "./components/PersonAmangeldi";
import { PersonTasybayev } from "./components/PersonTasybayev";
import { PersonStelvaga } from "./components/PersonStelvaga";
import { PersonOmarova } from "./components/PersonOmarova";
import { PersonGoncharenko } from "./components/PersonGoncharenko";
import { PersonKazhibekov } from "./components/PersonKazhibekov";
import { PersonBayandina } from "./components/PersonBayandina";

const roleColors = {
    'Научный руководитель, старший научный сотрудник': '#4a6fa5',
    'Старший научный сотрудник': '#4a6fa5',
    'Научный сотрудник': '#5a7a9a',
    'Младший научный сотрудник': '#5c8a7a',
    'Менеджер проекта': '#7a8a95',
    'Менеджер по кадрам по научной программе': '#7a8a95',
    'Программист': '#6a7e9a',
    'Разработчик': '#6a7e9a',
    'Разработчик ГИС': '#6a7e9a',
    'Разработчик базы данных': '#6a7e9a',
    'Разработчик математических моделей': '#6a7e9a',
    'Разработчик ИИ': '#6a7e9a',
    'Инженер-проектировщик': '#6a7e9a',
    'Специалист': '#7a8a95',
    'Специалист по автоматизированным системам': '#7a8a95',
};

const getRoleColor = (role) => roleColors[role] || clrs.textColor;

// Русская строка-роль (идентификатор для getRoleColor) -> ключ i18n для отображения
const roleKeys = {
    'Научный руководитель, старший научный сотрудник': 'team.role.principalInvestigatorSenior',
    'Старший научный сотрудник': 'team.role.seniorResearcher',
    'Научный сотрудник': 'team.role.researcher',
    'Младший научный сотрудник': 'team.role.juniorResearcher',
    'Менеджер проекта': 'team.role.projectManager',
    'Менеджер по кадрам по научной программе': 'team.role.hrManager',
    'Программист': 'team.role.programmer',
    'Разработчик': 'team.role.developer',
    'Разработчик ГИС': 'team.role.gisDeveloper',
    'Разработчик базы данных': 'team.role.databaseDeveloper',
    'Разработчик математических моделей': 'team.role.mathModelsDeveloper',
    'Разработчик ИИ': 'team.role.aiDeveloper',
    'Инженер-проектировщик': 'team.role.designEngineer',
    'Специалист': 'team.role.specialist',
    'Специалист по автоматизированным системам': 'team.role.automatedSystemsSpecialist',
};

// name: русская строка (fallback). nameKey: ключ i18n для отображения имени.
// role: русская строка-идентификатор (нужна для getRoleColor) — НЕ переводить здесь.
const teamData = [
    { key: 1,  name: 'Нефтисов Александр Витальевич',        nameKey: 'team.person.neftissov.fullName',        role: 'Научный руководитель, старший научный сотрудник', image: img2,      detail: <PersonNeftissov /> },
    { key: 2,  name: 'Белошицкий Андрей Александрович',       nameKey: 'team.person.biloshchytskyi.fullName',   role: 'Старший научный сотрудник',                       image: img1,      detail: <PersonBiloshchytskyi /> },
    { key: 3,  name: 'Казамбаев Ильяс Маратулы',             nameKey: 'team.person.kazambayev.fullName',       role: 'Научный сотрудник',                               image: img14,     detail: <PersonKazambayev /> },
    { key: 4,  name: 'Кириченко Лалита Николаевна',           nameKey: 'team.person.kirichenko.fullName',       role: 'Научный сотрудник',                               image: img15,     detail: <PersonKirichenko /> },
    { key: 5,  name: 'Токсанов Сапар Нурахметович',           nameKey: 'team.person.toxanov.fullName',          role: 'Научный сотрудник',                               image: img5,      detail: <PersonToxanov /> },
    { key: 6,  name: 'Жандаулет Елдос Жандаулетұлы',         nameKey: 'team.member.zhandaulet.name',           role: 'Разработчик математических моделей',              image: imgEldos,       detail: <PersonZhandaulet /> },
    { key: 7,  name: 'Абжанова Дилара Ерлановна',            nameKey: 'team.person.abzhanova.fullName',        role: 'Разработчик базы данных',                         image: img10,     detail: <PersonAbzhanova /> },
    { key: 8,  name: 'Кучанский Александр',                   nameKey: 'team.person.kuchanskyi.fullName',       role: 'Старший научный сотрудник',                       image: img3,      detail: <PersonKuchanskyi /> },
    { key: 9,  name: 'Камбарова Жулдуз Думанбековна',         nameKey: 'team.person.kambarova.fullName',        role: 'Менеджер проекта',                                image: img29,     detail: <PersonKambarova /> },
    { key: 10, name: 'Искакова Еренгуль Елкеновна',           nameKey: 'team.member.iskakova.name',             role: 'Менеджер по кадрам по научной программе',         image: user_icon, detail: null },
    { key: 11, name: 'Аубакирова Алия Муратовна',             nameKey: 'team.person.aubakirova.fullName',       role: 'Младший научный сотрудник',                       image: img27,     detail: <PersonAubakirova /> },
    { key: 12, name: 'Белощицкий Артем Андреевич',            nameKey: 'team.member.artemBiloshchytskyi.name',  role: 'Программист',                                     image: imgArtemBilo,   detail: <PersonArtemBiloshchytskyi /> },
    { key: 13, name: 'Белощицкий Евгений Андреевич',          nameKey: 'team.member.evgenyBiloshchytskyi.name', role: 'Программист',                                     image: imgEvgenyBilo,  detail: <PersonEvgenyBiloshchytskyi /> },
    { key: 14, name: 'Медетхан Айнур Сейтжанкызы',            nameKey: 'team.member.medetkhan.name',            role: 'Младший научный сотрудник',                       image: imgMedetkhan,   detail: <PersonMedetkhan /> },
    { key: 15, name: 'Амангелді Мағжан Айтмұратұлы',          nameKey: 'team.member.amangeldi.name',            role: 'Разработчик',                                     image: imgAmangeldi,   detail: <PersonAmangeldi /> },
    { key: 16, name: 'Тасыбаев Дамир Булатович',              nameKey: 'team.member.tasybayev.name',            role: 'Разработчик',                                     image: imgTasybayev,   detail: <PersonTasybayev /> },
    { key: 17, name: 'Вакансия',                              nameKey: 'team.member.vacancy.name',              role: 'Разработчик',                                     image: user_icon,      detail: null },
    { key: 18, name: 'Стельвага Олег Владимирович',           nameKey: 'team.member.stelvaga.name',             role: 'Разработчик',                                     image: imgStelvaga,    detail: <PersonStelvaga /> },
    { key: 19, name: 'Микряков Андрей Денисович',             nameKey: 'team.person.mikryakov.fullName',        role: 'Младший научный сотрудник',                       image: img25,     detail: <PersonMikryakov /> },
    { key: 20, name: 'Бақыткерей Батырбек',                   nameKey: 'team.person.bakytkereiuly.fullName',    role: 'Разработчик ГИС',                                 image: img11,     detail: <PersonBakytkereiuly /> },
    { key: 21, name: 'Омарова Перизат Танирбердиевна',        nameKey: 'team.member.omarova.name',              role: 'Научный сотрудник',                               image: imgOmarova,     detail: <PersonOmarova /> },
    { key: 22, name: 'Гончаренко Татьяна Андреевна',          nameKey: 'team.member.goncharenko.name',          role: 'Научный сотрудник',                               image: imgGoncharenko, detail: <PersonGoncharenko /> },
    { key: 23, name: 'Кажибеков Мади Нуржанович',             nameKey: 'team.member.kazhibekov.name',           role: 'Разработчик',                                     image: imgKazhibekov,  detail: <PersonKazhibekov /> },
    { key: 24, name: 'Бакбергенов Али Бахтыбаевич',           nameKey: 'team.member.bakbergenov.name',          role: 'Младший научный сотрудник',                       image: user_icon, detail: null },
    { key: 25, name: 'Абилькаиров Даулет Максутович',         nameKey: 'team.member.abilkairov.name',           role: 'Младший научный сотрудник',                       image: user_icon, detail: null },
    { key: 26, name: 'Абдибаев Жанузак Архабайулы',           nameKey: 'team.member.abdibaev.name',             role: 'Младший научный сотрудник',                       image: user_icon, detail: null },
    { key: 27, name: 'Жалмагамбетова Ултуар Каирболатовна',   nameKey: 'team.person.zhalmagambetova.fullName',  role: 'Специалист по автоматизированным системам',       image: img23,     detail: <PersonZhalmagambetova /> },
    { key: 28, name: 'Командиров Евгений Витальевич',         nameKey: 'team.member.komandirov.name',           role: 'Инженер-проектировщик',                           image: img19,     detail: <PersonKomandirov /> },
    { key: 29, name: 'Баяндина Гульмира Дуйсенбаевна',        nameKey: 'team.member.bayandina.name',            role: 'Специалист',                                      image: imgBayandina,   detail: <PersonBayandina /> },
    { key: 30, name: 'Оразбай Мұхтар Нұрболұлы',             nameKey: 'team.member.orazbay.name',              role: 'Разработчик ИИ',                                  image: user_icon, detail: null },
];

const CARD_W = 210;
const CARD_IMG_H = 240;
const CARD_TEXT_H = 130;

const MemberCard = ({ member, onOpenDetail }) => {
    const { t } = useTranslation();
    const hasDetail = member.detail !== null;
    return (
        <Flex
            vertical
            align="center"
            style={{
                width: CARD_W,
                borderRadius: 16,
                overflow: "hidden",
                background: clrs.white,
                boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                border: `1px solid ${clrs.whiter2}`,
                cursor: hasDetail ? "pointer" : "default",
                transition: "transform 0.2s, box-shadow 0.2s",
            }}
            className="member-card"
            onClick={() => hasDetail && onOpenDetail(member)}
        >
            <div style={{
                width: "100%",
                height: CARD_IMG_H,
                backgroundImage: `url(${member.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center top",
                flexShrink: 0,
            }} />
            <Flex
                vertical
                align="center"
                justify="space-between"
                gap={6}
                style={{
                    padding: "14px 12px 12px",
                    width: "100%",
                    height: CARD_TEXT_H,
                    boxSizing: "border-box",
                }}
            >
                <Flex vertical align="center" gap={5} style={{ flex: 1 }}>
                    <MyText
                        strong
                        style={{
                            fontSize: "0.83rem",
                            color: clrs.textColor,
                            textAlign: "center",
                            lineHeight: 1.35,
                            margin: 0,
                        }}
                    >
                        {t(member.nameKey, member.name)}
                    </MyText>
                    <MyText
                        italic
                        style={{
                            fontSize: "0.76rem",
                            color: getRoleColor(member.role),
                            textAlign: "center",
                            lineHeight: 1.3,
                            margin: 0,
                        }}
                    >
                        {t(roleKeys[member.role], member.role)}
                    </MyText>
                </Flex>
            </Flex>
        </Flex>
    );
};

const TeamPage = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [view, setView] = useState('cards');

    const handleOpen = (member) => {
        setSelected(member);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelected(null);
    };

    const columns = [
        {
            title: '',
            key: 'action',
            width: 56,
            render: (_, record) =>
                record.detail ? (
                    <Tooltip title={t('team.page.details')}>
                        <Button
                            type="text"
                            size="small"
                            icon={<EyeOutlined style={{ color: "#8fa3b8" }} />}
                            onClick={() => handleOpen(record)}
                            style={{ color: "#8fa3b8" }}
                        />
                    </Tooltip>
                ) : null,
        },
        {
            title: '',
            key: 'photo',
            width: 56,
            render: (_, record) => (
                <div
                    style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        backgroundImage: `url(${record.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center top",
                        border: `2px solid ${clrs.whiter2}`,
                    }}
                />
            ),
        },
        {
            title: t('fullName'),
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <MyText
                    style={{
                        cursor: record.detail ? "pointer" : "default",
                        color: record.detail ? "#4a6fa5" : "#5a6a7a",
                        fontWeight: record.detail ? 500 : 400,
                    }}
                    onClick={() => record.detail && handleOpen(record)}
                >
                    {t(record.nameKey, text)}
                </MyText>
            ),
        },
        {
            title: t('team.page.columnRole'),
            dataIndex: 'role',
            key: 'role',
            render: (role) => (
                <Tag
                    style={{
                        background: `${getRoleColor(role)}14`,
                        border: `1px solid ${getRoleColor(role)}30`,
                        color: getRoleColor(role),
                        borderRadius: 6,
                        fontWeight: 400,
                        fontSize: "0.82rem",
                    }}
                >
                    {t(roleKeys[role], role)}
                </Tag>
            ),
        },
    ];

    return (
        <div style={{ background: clrs.whiter3AquaGeo, minHeight: "100vh" }}>
            <Header />

            <style>{`
                .member-card:hover { transform: translateY(-4px); box-shadow: 0 8px 28px rgba(0,0,0,0.14) !important; }
            `}</style>

            <Flex
                justify="center"
                style={{ width: "100%", padding: "120px 20px 80px" }}
            >
                <Flex
                    vertical
                    gap={40}
                    style={{ width: "100%", maxWidth: 1440 }}
                >
                    {/* Header section */}
                    <Flex vertical align="center" gap={12} style={{ textAlign: "center" }}>
                        <Flex align="center" gap={12} justify="center">
                            <MyText
                                strong
                                style={{
                                    fontSize: "2.2rem",
                                    fontWeight: 900,
                                    color: clrs.textColor,
                                }}
                            >
                                {t('team.page.title')}
                            </MyText>
                        </Flex>
                        <MyText
                            style={{
                                fontSize: "1rem",
                                color: clrs.whiterBlacker,
                                maxWidth: 700,
                                lineHeight: 1.6,
                            }}
                        >
                            {t('team.page.projectDescription')}
                        </MyText>
                        <Flex gap={8} style={{ marginTop: 8 }}>
                            <Tag style={{ background: `${clrs.blue}15`, border: `1px solid ${clrs.blue}40`, color: clrs.blue, borderRadius: 20, padding: "4px 12px" }}>
                                {t('team.page.membersCount', { count: teamData.length })}
                            </Tag>
                            <Tag style={{ background: `${clrs.whiterGreen}25`, border: `1px solid ${clrs.whiterGreen}60`, color: clrs.darkerBlue, borderRadius: 20, padding: "4px 12px" }}>
                                {t('team.page.profilesCount', { count: teamData.filter(m => m.detail).length })}
                            </Tag>
                        </Flex>
                    </Flex>

                    {/* View toggle */}
                    <Flex justify="flex-end" gap={8}>
                        <Button
                            type={view === 'cards' ? 'primary' : 'default'}
                            onClick={() => setView('cards')}
                            style={{ borderRadius: 8 }}
                        >
                            {t('team.page.cards')}
                        </Button>
                        <Button
                            type={view === 'table' ? 'primary' : 'default'}
                            onClick={() => setView('table')}
                            style={{ borderRadius: 8 }}
                        >
                            {t('team.page.table')}
                        </Button>
                    </Flex>

                    {/* Cards view */}
                    {view === 'cards' && (
                        <Flex wrap="wrap" gap={24} justify="center">
                            {teamData.map(member => (
                                <MemberCard key={member.key} member={member} onOpenDetail={handleOpen} />
                            ))}
                        </Flex>
                    )}

                    {/* Table view */}
                    {view === 'table' && (
                        <div style={{
                            background: clrs.white,
                            borderRadius: 16,
                            overflow: "hidden",
                            boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                        }}>
                            <Table
                                columns={columns}
                                dataSource={teamData}
                                pagination={false}
                                rowKey="key"
                                size="middle"
                                onRow={(record) => ({
                                    style: {
                                        cursor: record.detail ? "pointer" : "default",
                                        transition: "background 0.15s",
                                    },
                                })}
                            />
                        </div>
                    )}
                </Flex>
            </Flex>

            {/* Detail modal */}
            <Modal
                title={
                    <Flex align="center" gap={10}>
                        {selected && (
                            <div style={{
                                width: 36,
                                height: 36,
                                borderRadius: "50%",
                                backgroundImage: `url(${selected?.image})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center top",
                                flexShrink: 0,
                            }} />
                        )}
                        <span>{selected ? t(selected.nameKey, selected.name) : ''}</span>
                    </Flex>
                }
                open={open}
                onOk={handleClose}
                onCancel={handleClose}
                footer={[
                    <Button key="ok" type="primary" onClick={handleClose} style={{ borderRadius: 8 }}>
                        {t('close')}
                    </Button>
                ]}
                width={900}
                style={{ top: 40 }}
                styles={{ body: { maxHeight: "70vh", overflowY: "auto", padding: "24px" } }}
            >
                {selected?.detail}
            </Modal>

            <Footer />
        </div>
    );
};

export default TeamPage;
